import { inject, observer } from 'mobx-react'
import queryString from 'query-string'
import React, { useCallback, useEffect } from 'react'
import Turnstile from 'react-turnstile'
import { PageView, TextTurnstile, TurnstileContainer } from './index.styled'
import { useLocation } from 'react-router-dom'

function TurnstileVerify(props) {
  const location = useLocation()

  const { language } = props
  const { lang } = queryString.parse(location.search)

  const onInit = useCallback(() => {
    props.language.setLanguage(lang)
  }, [lang, props.language])

  useEffect(() => {
    onInit()
  }, [onInit])

  const onVerify = (token, boundTurnstile) => {
    if (token) {
      window.ReactNativeWebView?.postMessage(JSON.stringify({ token: token }))
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      window.location.reload()
    }, 300000) // 5 Min
    return () => clearInterval(interval)
  }, [])

  return (
    <PageView>
      <TextTurnstile>
        {language.getMsg('Verify', 'ยืนยันบัญชี')}
        <span>
          {language.getMsg(
            '(Click the box if is not clicked)',
            '(กดที่ช่องด้านล่าง หากไม่ได้ตรวจสอบอัตโนมัติ)'
          )}
        </span>
      </TextTurnstile>
      <TurnstileContainer>
        <Turnstile
          sitekey={
            process.env.REACT_APP_TURNSTILE_SITE_KEY ||
            '0x4AAAAAAAwmWTHbYb3D7Un7'
          }
          retry="auto"
          refreshExpired="auto"
          size="flexible"
          onSuccess={onVerify}
          language={language?.selected || 'en'}
        />
      </TurnstileContainer>
    </PageView>
  )
}

export default inject('language')(observer(TurnstileVerify))
